import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomInputTypesDefinitionsService } from '../../../rdsap/services/configuration/custom-input-types-definitions.service';
import { AvailableInputTypeV0 } from '../../../rdsap-api/model/availableInputTypeV0';

// Define the custom data service
// this service overrides the @ngrx/data default data service and fetches data with custom services
@Injectable()
export class InputTypesDataService extends DefaultDataService<AvailableInputTypeV0> {
  constructor(
    http: HttpClient,
    httpUrlGenerator: HttpUrlGenerator,
    private customService: CustomInputTypesDefinitionsService
  ) {
    super('CustomInputTypes', http, httpUrlGenerator);
  }

  getAll(): Observable<AvailableInputTypeV0[]> {
    return this.customService.getInputTypes();
  }

}
